import { useEffect } from "react";
import { MarketType } from "../types";

/** Meta Pixel IDs per market (only KR/HK have pixels). */
const META_PIXEL_IDS: Partial<Record<MarketType, string>> = {
  KR: "240533622092057",
  HK: "1145492722147006",
};

const SCRIPT_ID = "meta-pixel";
const NOSCRIPT_ID = "meta-pixel-noscript";

function injectMetaPixel(pixelId: string) {
  if (document.getElementById(SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
     n.queue=[];t=b.createElement(e);t.async=!0;
     t.src=v;s=b.getElementsByTagName(e)[0];
     s.parentNode.insertBefore(t,s)
    }(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  `;

  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.id = NOSCRIPT_ID;
  noscript.innerHTML = `
    <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"
    />
  `;

  document.body.appendChild(noscript);
}

/**
 * Injects Meta (Facebook) Pixel once when market is KR or HK.
 * No-op for other markets or if already injected.
 */
export default function useMetaPixel(market: MarketType | null) {
  useEffect(() => {
    const pixelId = market ? META_PIXEL_IDS[market] : undefined;

    if (!pixelId) return;

    injectMetaPixel(pixelId);
  }, [market]);
}
